import React from 'react'
import { Box, SxProps } from '@mui/material'
import DeleteIcon from '@mui/icons-material/Delete'
import ImageIcon from '@mui/icons-material/Image'

interface Props {
    filename: string
    handleClick(): void
    handleDelete(): void
    sx?: SxProps
}

export const FileList = ({
    filename,
    handleClick,
    handleDelete,
    sx,
}: Props) => {
    return (
        <Box
            sx={{
                width: { xs: '100%', md: '47%' },
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                p: '20px',
                background: 'var(--surface-soft)',
                border: '1px solid var(--border-color)',
                borderRadius: '8px',
                ...sx,
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    cursor: 'pointer',
                }}
                onClick={handleClick}
            >
                <ImageIcon sx={{ mr: '5px' }} color="primary" />
                {filename}
            </Box>
            <DeleteIcon sx={{ cursor: 'pointer' }} onClick={handleDelete} />
        </Box>
    )
}
